import { Injectable } from '@angular/core';
import { IAMObject } from '../auth';
import { AuthenticationService, IAMService } from "../services.module";

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  constructor(
    private iamService: IAMService,
    private authenticationService: AuthenticationService,
  ) { }

  async init() {
    const iamObject = await this.iamService.getIAMObject();
    const authToken = await this.iamService.getAuthToken();
    if (iamObject && authToken) {
      await this.getAppIntializeData(iamObject);
    }
  }

  private async getAppIntializeData(iamObject: IAMObject) {
    const loggedInUser = await this.authenticationService.getLoggedInUserInfo();
  }
}
